module.exports = __webpack_public_path__ + "media/images/slider/slider1-e633ce277b5ce25f3062a3197ea10bf6.JPG";